import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-0"}],["path",{"d":"M12 12v-8","key":"svg-1"}],["path",{"d":"M9 7l3 -3l3 3","key":"svg-2"}]]

const IconSwipeUp = createReactComponent('outline', 'swipe-up', 'SwipeUp', __iconNode);

export default IconSwipeUp;